// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__gcdJi","content":"Consent_content__1JvGf","footer":"Consent_footer__3-f2v"};